import api from "./api";

export function getHuaweiMmeDefaultParameters() {
  return new Promise((resolve, reject) => {
    api
      .get("/huawei-mme-default-parameters")
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getById(id) {
  return new Promise((resolve, reject) => {
    api
      .get(`/huawei-mme-default-parameters/${id}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function update(values) {
  return new Promise((resolve, reject) => {
    api({
      method: "put",
      url: `/huawei-mme-default-parameters`,
      data: values,
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
